import React from 'react';
import ChatDashboardHome from './chatDashboardHome';

const ChatDashboard: React.FC = () => {
	return <ChatDashboardHome />;
};

export default ChatDashboard;
